import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import { GetGoodsPackingsRequestQuery, GetOrderGoodsPackingsResponseData } from "../types/order"
import api from "../client"

const getData = async (getGoodsPackingsQueryParams: GetGoodsPackingsRequestQuery) => {
  const {
    unloadingCountryCode,
    loadingCountryCode,
  } = getGoodsPackingsQueryParams

  const { data } = await api.get(`/goods/packings/${loadingCountryCode}/${unloadingCountryCode}`)

  return data
}

export const useGoodsPackings = (getGoodsPackingsQueryParams: GetGoodsPackingsRequestQuery):
  QueryObserverBaseResult<GetOrderGoodsPackingsResponseData> => {

  const {
    unloadingCountryCode,
    loadingCountryCode,
  } = getGoodsPackingsQueryParams

  const { data, ...props } = useQuery<GetOrderGoodsPackingsResponseData>(
    queryKeys.GOODS_PACKINGS(getGoodsPackingsQueryParams),
    () => getData(getGoodsPackingsQueryParams),
    {
      enabled: Boolean(unloadingCountryCode && loadingCountryCode)
    }
  )

  return { data, ...props }
}
